/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useCallback, useContext, useEffect } from 'react'
import rootStore from '../../../store/RootStore'
import { observer } from 'mobx-react'
import SearchForm, { SearchFormActionBar } from './SearchForm'
import {
  Box,
  HStack,
  Spacer,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from '@chakra-ui/react'

import { CustomTabList } from '../../ui/CustomTabList'
import SearchResults from './SearchResults'
import { LayoutContext } from '../../ui/Layout/Layout'

const SearchPanel = observer(() => {
  const {
    searchStore: {
      invalidateSearch,
      currentResults,
      filteredCurrentResult,
      setSearchDrawerVisible,
      searchDrawerVisible,
    },
  } = rootStore
  const { isRightPanelOpen } = useContext(LayoutContext)
  useEffect(() => {
    if (!isRightPanelOpen) {
      setSearchDrawerVisible(false)
    }
  }, [isRightPanelOpen, setSearchDrawerVisible])
  const handleSearchSubmit = useCallback(() => {
    setSearchDrawerVisible(true)
    currentResults()
  }, [currentResults, setSearchDrawerVisible])

  const handleTabChange = useCallback(() => {}, [])

  useEffect(() => {
    if (!searchDrawerVisible) {
      invalidateSearch()
    }
  }, [invalidateSearch, searchDrawerVisible])

  return (
    <Box
      position="relative"
      w="100%"
      maxWidth="100%">
      <VStack
        w="100%"
        padding="30px 20px 0 20px"
        backgroundColor="brand.white"
        zIndex="9"
        alignItems="flex-start">
        <HStack
          mt="2px"
          position="relative"
          background={'brand.white'}>
          <Text textStyle="h2">Search</Text>
          <Spacer />
        </HStack>
        <Box
          p="16px 0 0"
          w="100%">
          <SearchForm
            onSubmit={handleSearchSubmit}
            p="12px 0"
          />
          <SearchFormActionBar
            p="12px 0"
            onSubmit={handleSearchSubmit}
          />
        </Box>
      </VStack>

      <Tabs onChange={handleTabChange}>
        <CustomTabList
          w="100%"
          items={getTabItems(
            filteredCurrentResult.length,
            filteredCurrentResult.length,
          )}
        />

        <TabPanels
          p="0 20px 0"
          top="16px"
          position="relative"
          overflowX="none"
          overflowY="auto"
          h={{ base: 'calc(100vh - 340px)', xl: 'calc(100vh - 240px)' }}>
          <TabPanel p="0">
            <SearchResults results={filteredCurrentResult} />
          </TabPanel>
          <TabPanel p="0">
            <SearchResults results={filteredCurrentResult} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
})

const getTabItems = (currentAmount, differentAmount) => [
  {
    label: `Current filter (${currentAmount})`,
    id: '1',
  },
  {
    label: `Different filters (${differentAmount})`,
    id: '2',
  },
]

SearchPanel.propTypes = {}

export default SearchPanel
